// Mesure la largeur du picto d'un logo (.logo-block--with-picto) et expose
// `--logo-picto-offset` (largeur du picto + gap interne du logo) sur le parent,
// pour que les blocs frères (ex. texte sous le logo dans le footer) puissent
// s'aligner sur le mot du logo plutôt que sur le picto.

/** @param {HTMLElement} logo */
const updateOffset = (logo) => {
  const picto = logo.querySelector('.logo-block__picto');
  const parent = logo.parentElement;
  if (!picto || !parent) return;

  const styles = getComputedStyle(logo);
  const gap = parseFloat(styles.columnGap) || parseFloat(styles.gap) || 0;
  const offset = picto.getBoundingClientRect().width + gap;

  parent.style.setProperty('--logo-picto-offset', `${offset}px`);
};

for (const logo of document.querySelectorAll('.logo-block--with-picto')) {
  updateOffset(logo);

  // Recalcule quand la taille du logo change (responsive, chargement du picto, etc.)
  const observer = new ResizeObserver(() => updateOffset(logo));
  observer.observe(logo);
}
